import React from "react";

function NavigationItem({ icon, label, isActive, handleClick }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        maxWidth: "210px",
        gap: "8px",
      }}
    >
      <div
        style={{
          width: "9px",
          height: "45px",
          flexShrink: "0",
          borderRadius: "4px",
          background: isActive ? "#007BFF" : "#FFF",
        }}
      ></div>
      <button
        onClick={handleClick}
        style={{
          display: "flex",
          width: "100%",
          maxWidth: "180px",
          gap: "20px",
          alignItems: "center",
          padding: "12px 26px",
          backgroundColor: isActive
            ? "rgba(0, 123, 255, 1)"
            : "rgba(255, 255, 255, 1)",
          color: isActive ? "rgba(255, 255, 255, 1)" : "rgba(57, 62, 67, 1)",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          font: "500 14px Montserrat, sans-serif",
          whiteSpace: "nowrap",
          letterSpacing: isActive ? "0" : "-1px",
          "&:focus": {
            outline: "2px solid rgba(0, 123, 255, 0.5)",
            outlineOffset: "2px",
          },
        }}
      >
        <img
          src={icon}
          alt=""
          loading="lazy"
          style={{
            aspectRatio: "1",
            objectFit: "contain",
            objectPosition: "center",
            width: "20px",
            filter: isActive ? "brightness(0) invert(1)" : "none",
          }}
        />
        <span>{label}</span>
      </button>
    </div>
  );
}

export default NavigationItem;
